"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeInteractionManagers = void 0;
var mergeInteractionManagers = function (main, fallback) { return ({
    mode: main.mode,
    createInteractiveElementProps: function (item, treeId, actions, renderFlags) { return (__assign(__assign({}, fallback.createInteractiveElementProps(item, treeId, actions, renderFlags)), main.createInteractiveElementProps(item, treeId, actions, renderFlags))); },
}); };
exports.mergeInteractionManagers = mergeInteractionManagers;
